import { type FC } from 'react';
import cn from 'classnames';
import { t } from 'i18next';

import { ChevronsAnimation } from '@/components/Animations/ChevronsAnimation/ChevronsAnimation';
import { StringMain, StringXSmall } from '@/components/Typography/Typography';

import css from './styles.module.scss';

interface EarnRevenueItemProps {
  percentage: { basePercent: number; vipPercent: number };
  volume: number;
  isVip: boolean | undefined;
  isActive?: boolean;
}

const EarnRevenueItem: FC<EarnRevenueItemProps> = ({
  percentage,
  volume,
  isActive,
  isVip,
}) => {
  const vipStyle: boolean = !!(isVip && isActive);

  return (
    <div className={css.revenueItem}>
      <div className="flex items-center gap-2">
        {isActive && <ChevronsAnimation className="w-6 h-6 shrink-0" />}
        <StringMain
          weight="bold"
          className={cn(
            '!leading-1.2',
            isActive && !isVip && '!text-gold',
            vipStyle && '!text-white/40 relative text-crossed-out',
          )}
        >
          {`${percentage.basePercent}%`}
        </StringMain>
        {vipStyle && (
          <StringMain weight="bold" className={cn('!leading-1.2 !text-gold')}>
            {`${percentage.vipPercent}%`}
          </StringMain>
        )}
        {isActive && (
          <StringXSmall className="!text-white/40">
            {t('Your share')}
          </StringXSmall>
        )}
      </div>
      <StringMain
        weight={isActive ? 'bold' : 'regular'}
      >{`$ ${volume}${volume > 0 ? '+' : ''}`}</StringMain>
    </div>
  );
};

export { EarnRevenueItem };
